import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import { FindConsultantsOutput, FindConsultantsParams } from './consultants.types';

const PATH = 'consultants';

export const findConsultants = (params: FindConsultantsParams, signal?: AbortSignal) =>
  restApi.get<FindConsultantsOutput>(PATH, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });
